import React from 'react'

export const Cases = () => {
  return (
    <div>Cases</div>
  )
}
